import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    ToggleCategoryArchiveStatusAdminMutationMutation,
    ToggleCategoryArchiveStatusAdminMutationMutationVariables 
} from "../../../../../schemaTypes";
import React, { ReactElement } from "react";

import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

export const toggleCategoryArchiveStatusAdminMutation = gql`
  mutation ToggleCategoryArchiveStatusAdminMutation(
        $categoryId: String!
        $isArchive: Boolean!
    ) {
        toggleCategoryArchiveStatusAdmin(
            categoryId: $categoryId
            isArchive: $isArchive
            ) {
            errors {
                path
                message
            }
            message
        }
  }
`;

interface Props {
  children: (
    data: {
      submitToggleCategoryArchiveStatusAdmin: (
        values: ToggleCategoryArchiveStatusAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      toggleCategoryArchiveStatusAdminData: any | null; 
    }
  ) => ReactElement | null;
}

export const ToggleCategoryArchiveStatusAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    ToggleCategoryArchiveStatusAdminMutationMutation,
    ToggleCategoryArchiveStatusAdminMutationMutationVariables
  >(
    toggleCategoryArchiveStatusAdminMutation
  );

  const submitToggleCategoryArchiveStatusAdmin = async (values: ToggleCategoryArchiveStatusAdminMutationMutationVariables) => {
    const { data: {toggleCategoryArchiveStatusAdmin} }:any = await mutate({ variables: values });

    if (toggleCategoryArchiveStatusAdmin?.errors) {
      return {error: normalizeErrors(toggleCategoryArchiveStatusAdmin.errors), toggleCategoryArchiveStatusAdmin: null};
    }

    return {
      error: null,
      toggleCategoryArchiveStatusAdmin
    };
  };

  const message = data?.toggleCategoryArchiveStatusAdmin?.message || null;

  return children({
    submitToggleCategoryArchiveStatusAdmin,
    loading,
    error,
    message,
    toggleCategoryArchiveStatusAdminData: data,
  });
};